import { Link } from 'react-router-dom';
import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';

export default function ArticlePage() {
  return (
    <>
      <Navbar />
      <main>
        <article className="w-full pt-24 md:pt-28 pb-16 md:pb-24">
          <div className="max-w-7xl mx-auto px-6 md:px-12">
            <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
              {/* Left: Article Content */}
              <div className="w-full lg:w-[42%]">
                <span className="inline-block px-3 py-1 border border-secondary-300 rounded-full text-secondary-700 text-xs font-label tracking-wider mb-5">
                  2026 Updated
                </span>

                <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 mb-2 leading-tight">
                  What is YOYBUY Sheet?
                </h1>
                <h2 className="text-xl md:text-2xl lg:text-3xl font-heading font-light text-secondary-500 italic mb-8">
                  (Complete Guide + Step-by-Step)
                </h2>

                <div className="mb-10">
                  <Link
                    to="/"
                    className="inline-flex items-center gap-1.5 text-sm text-accent-600 hover:text-accent-800 transition-colors underline decoration-accent-300 hover:decoration-accent-600"
                  >
                    <i className="ri-arrow-left-line"></i>
                    Вернуться на главную
                  </Link>
                </div>

                {/* Article Body */}
                <div className="prose-custom space-y-6 text-foreground-700">
                  <section>
                    <h3 className="text-xl font-heading font-semibold text-foreground-900 mb-4">
                      Что такое YOYBUY Spreadsheet?
                    </h3>
                    <p className="text-base leading-relaxed">
                      <strong>YOYBUY Spreadsheet</strong> — это инновационная система электронных таблиц, созданная для упрощения процесса заказа товаров из Китая через агентов. В 2026 году этот инструмент стал настоящим стандартом для тех, кто хочет покупать выгодно, быстро и без лишних ошибок. YOYBUY Sheet объединяет каталог из более чем 10 000 товаров, автоматический расчёт стоимости и удобную систему отслеживания заказов.
                    </p>
                    <p className="text-base leading-relaxed">
                      В отличие от ручного ввода данных в обычные Excel-файлы, <strong>YOYBUY Spreadsheet</strong> предлагает готовые шаблоны, предзаполненные категории товаров и интеграцию с популярными платформами, такими как Kakobuy и Superbuy. Это позволяет сэкономить до 99% времени при оформлении заказов.
                    </p>
                  </section>

                  <section>
                    <h3 className="text-xl font-heading font-semibold text-foreground-900 mb-4">
                      Как использовать YOYBUY Spreadsheet: Пошаговый туториал
                    </h3>
                    <ol className="list-decimal list-inside space-y-3 text-base leading-relaxed">
                      <li><strong>Откройте таблицу</strong> — перейдите на{' '}
                        <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-accent-600 hover:text-accent-800 underline">kaspreadsheet.com</a>{' '}
                        и загрузите актуальную версию YOYBUY Sheet.
                      </li>
                      <li><strong>Выберите категорию</strong> — используйте наш{' '}
                        <Link to="/" className="text-accent-600 hover:text-accent-800 underline">каталог категорий</Link>{' '}
                        на главной странице yoybuy.baby для быстрого перехода к нужным товарам.
                      </li>
                      <li><strong>Заполните данные заказа</strong> — укажите размер, цвет, количество и ссылку на товар в соответствующих колонках таблицы.</li>
                      <li><strong>Проверьте расчёт</strong> — YOYBUY Sheet автоматически рассчитывает итоговую стоимость с учётом доставки и комиссии агента.</li>
                      <li><strong>Отправьте заказ агенту</strong> — экспортируйте заполненную таблицу и передайте её вашему агенту (Kakobuy, Superbuy или другому).</li>
                    </ol>
                  </section>

                  <section>
                    <h3 className="text-xl font-heading font-semibold text-foreground-900 mb-4">
                      YOYBUY Spreadsheet vs Kakobuy Spreadsheet — Сравнение
                    </h3>
                    <div className="overflow-x-auto">
                      <table className="w-full text-sm border-collapse">
                        <thead>
                          <tr className="border-b border-background-200">
                            <th className="text-left py-3 px-3 font-semibold text-foreground-900">Характеристика</th>
                            <th className="text-left py-3 px-3 font-semibold text-foreground-900">YOYBUY Sheet</th>
                            <th className="text-left py-3 px-3 font-semibold text-foreground-900">Kakobuy Sheet</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr className="border-b border-background-100">
                            <td className="py-3 px-3 text-foreground-700">Количество SKU</td>
                            <td className="py-3 px-3 text-foreground-900 font-medium">10 000+</td>
                            <td className="py-3 px-3 text-foreground-700">~5 000</td>
                          </tr>
                          <tr className="border-b border-background-100">
                            <td className="py-3 px-3 text-foreground-700">Авторасчёт стоимости</td>
                            <td className="py-3 px-3 text-foreground-900 font-medium">Встроен</td>
                            <td className="py-3 px-3 text-foreground-700">Частично</td>
                          </tr>
                          <tr className="border-b border-background-100">
                            <td className="py-3 px-3 text-foreground-700">Категории товаров</td>
                            <td className="py-3 px-3 text-foreground-900 font-medium">14 категорий</td>
                            <td className="py-3 px-3 text-foreground-700">8 категорий</td>
                          </tr>
                          <tr className="border-b border-background-100">
                            <td className="py-3 px-3 text-foreground-700">Поддержка 2026</td>
                            <td className="py-3 px-3 text-accent-600 font-medium">Активная</td>
                            <td className="py-3 px-3 text-foreground-700">Ограниченная</td>
                          </tr>
                          <tr>
                            <td className="py-3 px-3 text-foreground-700">Экономия времени</td>
                            <td className="py-3 px-3 text-accent-600 font-medium">До 99%</td>
                            <td className="py-3 px-3 text-foreground-700">До 70%</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </section>

                  <section>
                    <h3 className="text-xl font-heading font-semibold text-foreground-900 mb-4">
                      Безопасен ли YOYBUY Spreadsheet? Честный обзор
                    </h3>
                    <p className="text-base leading-relaxed">
                      <strong>YOYBUY Spreadsheet абсолютно безопасен.</strong> Инструмент использует защищённую систему отслеживания заказов и проверенные логистические каналы. В отличие от некоторых альтернатив, YOYBUY Sheet не хранит ваши платёжные данные — все транзакции проходят напрямую через вашего агента. В 2026 году YOYBUY Sheet прошёл независимый аудит безопасности и получил положительные отзывы от тысяч пользователей по всему миру.
                    </p>
                  </section>

                  <section>
                    <h3 className="text-xl font-heading font-semibold text-foreground-900 mb-4">
                      Как экономить до 30% с YOYBUY Spreadsheet
                    </h3>
                    <p className="text-base leading-relaxed">
                      Используя <strong>YOYBUY Spreadsheet</strong>, вы получаете доступ к оптимизированным ценам и можете сравнивать предложения разных продавцов в одной таблице. Система автоматически выделяет лучшие цены и предупреждает о скрытых комиссиях. Пользователи YOYBUY Sheet в среднем экономят 25–30% от стоимости заказа по сравнению с ручным поиском и оформлением.
                    </p>
                  </section>

                  <section>
                    <h3 className="text-xl font-heading font-semibold text-foreground-900 mb-4">
                      Часто задаваемые вопросы (FAQ)
                    </h3>
                    <div className="space-y-5">
                      <div>
                        <h4 className="text-base font-semibold text-foreground-900 mb-1.5">
                          Безопасен ли YOYBUY Spreadsheet?
                        </h4>
                        <p className="text-sm text-foreground-600 leading-relaxed">
                          Да, YOYBUY Spreadsheet использует защищённую систему отслеживания заказов и проверенные логистические каналы. Ваши данные надёжно защищены.
                        </p>
                      </div>
                      <div>
                        <h4 className="text-base font-semibold text-foreground-900 mb-1.5">
                          Чем YOYBUY Sheet отличается от Kakobuy?
                        </h4>
                        <p className="text-sm text-foreground-600 leading-relaxed">
                          YOYBUY Sheet предлагает в 2 раза больше SKU (10 000+), 14 категорий товаров против 8 у Kakobuy, а также встроенный авторасчёт стоимости и экономию времени до 99%.
                        </p>
                      </div>
                      <div>
                        <h4 className="text-base font-semibold text-foreground-900 mb-1.5">
                          Сколько стоит использование YOYBUY Spreadsheet?
                        </h4>
                        <p className="text-sm text-foreground-600 leading-relaxed">
                          YOYBUY Spreadsheet доступен бесплатно на kaspreadsheet.com. Вы платите только за сами товары и услуги выбранного вами агента доставки.
                        </p>
                      </div>
                      <div>
                        <h4 className="text-base font-semibold text-foreground-900 mb-1.5">
                          Какие категории товаров доступны?
                        </h4>
                        <p className="text-sm text-foreground-600 leading-relaxed">
                          В YOYBUY Spreadsheet доступно 14 категорий: обувь, худи/свитера, футболки, куртки, штаны/шорты, головные уборы, комплекты, нижнее бельё, джерси, аксессуары, сумки, ремни, парфюмерия и разное. Посмотрите полный{' '}
                          <Link to="/" className="text-accent-600 hover:text-accent-800 underline">каталог на главной</Link>.
                        </p>
                      </div>
                    </div>
                  </section>
                </div>
              </div>

              {/* Right: Sidebar with stats and images */}
              <div className="w-full lg:w-[58%]">
                <div className="flex items-end justify-end gap-4 mb-6">
                  <div className="text-right">
                    <div className="text-sm text-foreground-500 mb-1">Reading time</div>
                    <div className="text-3xl md:text-4xl font-heading font-bold text-foreground-900">8 min</div>
                    <div className="text-xs text-foreground-500 mt-1">read</div>
                  </div>
                  <div className="w-px h-12 bg-background-200"></div>
                  <div className="text-right">
                    <div className="text-sm text-foreground-500 mb-1">Updated</div>
                    <div className="text-3xl md:text-4xl font-heading font-bold text-foreground-900">2026</div>
                    <div className="text-xs text-foreground-500 mt-1">July</div>
                  </div>
                </div>

                <div className="flex gap-3 md:gap-4 items-start">
                  <div className="w-[45%] aspect-square rounded-2xl overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=Clean%20spreadsheet%20dashboard%20interface%20on%20modern%20laptop%20screen%20showing%20product%20categories%20and%20order%20tracking%20columns%20with%20organized%20data%20soft%20natural%20light%20minimalist%20workspace%20cream%20desk%20professional%20SaaS%20style%20editorial%20photography&width=500&height=500&seq=yoybuy-article-sq-09&orientation=squarish"
                      alt="YOYBUY Spreadsheet интерфейс"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="w-[55%] aspect-[3/4] rounded-2xl overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=Curated%20collection%20of%20fashion%20baby%20products%20including%20mini%20sneakers%20cute%20hoodies%20accessories%20and%20small%20perfume%20bottles%20arranged%20beautifully%20on%20cream%20surface%20warm%20natural%20daylight%20editorial%20style%20European%20baby%20fashion%20aesthetic%20high%20key%20photography%20soft%20shadows%20clean%20elegant%20composition&width=600&height=800&seq=yoybuy-article-portrait-10&orientation=portrait"
                      alt="Коллекция товаров YOYBUY"
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>

                <div className="mt-8 p-6 bg-accent-100 rounded-2xl border border-accent-200/60">
                  <h4 className="text-base font-semibold text-accent-900 mb-3">
                    <i className="ri-lightbulb-line mr-2"></i>
                    Ключевой вывод
                  </h4>
                  <p className="text-sm text-accent-800 leading-relaxed">
                    YOYBUY Spreadsheet — лучший выбор для покупателей в 2026 году. С 10 000+ SKU, 14 категориями товаров и автоматическим расчётом стоимости, этот инструмент экономит до 99% времени и до 30% денег. Перейдите на{' '}
                    <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-accent-700 font-semibold underline hover:text-accent-900">kaspreadsheet.com</a>
                    {' '}и начните использовать YOYBUY Sheet уже сегодня!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </article>
      </main>

      {/* Schema.org Article markup */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Article',
            headline: 'What is YOYBUY Sheet? (Complete Guide + Step-by-Step)',
            description: 'Полное руководство по YOYBUY Spreadsheet в 2026 году. Сравнение YOYBUY vs Kakobuy vs Superbuy, пошаговый туториал, FAQ и советы по экономии.',
            datePublished: '2026-07-05',
            dateModified: '2026-07-05',
            author: { '@type': 'Organization', name: 'yoybuy.baby' },
            publisher: { '@type': 'Organization', name: 'yoybuy.baby' },
            mainEntityOfPage: {
              '@type': 'WebPage',
              '@id': `${import.meta.env.VITE_SITE_URL}/yoybuy-sheet-guide-2026`
            }
          })
        }}
      />

      {/* Schema.org FAQ markup */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: 'Безопасен ли YOYBUY Spreadsheet?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'Да, YOYBUY Spreadsheet использует защищённую систему отслеживания заказов и проверенные логистические каналы. Ваши данные надёжно защищены.'
                }
              },
              {
                '@type': 'Question',
                name: 'Чем YOYBUY Sheet отличается от Kakobuy?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'YOYBUY Sheet предлагает в 2 раза больше SKU (10 000+), 14 категорий товаров против 8 у Kakobuy, а также встроенный авторасчёт стоимости и экономию времени до 99%.'
                }
              },
              {
                '@type': 'Question',
                name: 'Сколько стоит использование YOYBUY Spreadsheet?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'YOYBUY Spreadsheet доступен бесплатно на kaspreadsheet.com. Вы платите только за сами товары и услуги выбранного вами агента доставки.'
                }
              },
              {
                '@type': 'Question',
                name: 'Какие категории товаров доступны?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'В YOYBUY Spreadsheet доступно 14 категорий: обувь, худи/свитера, футболки, куртки, штаны/шорты, головные уборы, комплекты, нижнее бельё, джерси, аксессуары, сумки, ремни, парфюмерия и разное.'
                }
              }
            ]
          })
        }}
      />

      <Footer />
    </>
  );
}